import React from 'react'
import PropTypes from 'prop-types'

// Path
import { PATH_TICKET_VIEW } from 'routes/paths'

// Components
import Link from 'ui/Link'
import Text from 'ui/Text'
import Button from 'ui/Button'

// Models
import TicketInfoModel from 'models/Ticket'

export const ColumnTicketMobile = ({ row }) => {
  return (
    <div
      style={{
        padding: '22px 17px',
        backgroundColor: 'rgba(224, 240, 255, 0.35)',
        border: '1px solid rgba(92, 173, 250, 0.35)',
        borderRadius: 5,
      }}
    >
      <Text bold color="#000000" size={15} paddingBottom={5}>
        {row.category}
      </Text>
      <div className="d-flex">
        <Text style={{ width: '100px', color: '#000000' }}>Ticket no.:</Text>
        <Text>{row.ticketNo}</Text>
      </div>
      <div className="d-flex">
        <Text style={{ width: '100px', color: '#000000' }}>Date raised:</Text>
        <Text>{row.raisedAt}</Text>
      </div>
      <div className="d-flex">
        <Text style={{ width: '100px', color: '#000000' }}>Category:</Text>
        <Text>{row.category}</Text>
      </div>
      <div className="d-flex">
        <Text style={{ width: '100px', color: '#000000' }}>Type:</Text>
        <Text>{row.type}</Text>
      </div>
      <div className="d-flex">
        <Text style={{ width: '100px', color: '#000000' }}>Date closed:</Text>
        <Text>{row.closedAt}</Text>
      </div>
      <Link path={PATH_TICKET_VIEW} params={{ id: row.id }}>
        <Button style={{ marginTop: 10, padding: '0 20px' }}>View</Button>
      </Link>
    </div>
  )
}

ColumnTicketMobile.propTypes = {
  row: PropTypes.instanceOf(TicketInfoModel),
}

ColumnTicketMobile.defaultProps = {
  row: new TicketInfoModel(),
}

export default ColumnTicketMobile
